<template>
  <div>
    <vue-phone-number-input
      v-model="phoneModel"
      :default-country-code="defaultCountryCode"
      @update="updatePhone"
      ref="phone-10"
      :translations="translations"
    />
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { __PhoneOption } from "@/Utils/options";
import { parsePhoneNumberFromString } from "libphonenumber-js";
export default {
  name: "PhoneNumber",
  components: { VuePhoneNumberInput },
  props: ["value", "rules"],
  data() {
    return {
      phoneModel: "",
      defaultCountryCode: "KW",
      phone_number: JSON.parse(JSON.stringify(__PhoneOption)),
      translations: {
        countrySelectorLabel: this.$i18n.t("Country"),
        countrySelectorError: this.$i18n.t("Choose Country"),
        phoneNumberLabel: this.$i18n.t("Phone Number"),
        example: this.$i18n.t("Example :")
      }
    };
  },
  computed: {
    formattedPhoneNumber() {
      return this.value ? this.value.formattedNumber : "";
    }
  },
  methods: {
    updatePhone(props) {
      this.setPhone(props.formattedNumber, props.isValid);
      if (!props.isValid) {
        this.$emit("update:errors", "Please enter a valid phone number.");
      } else {
        this.$emit("update:errors", "");
      }
    },
    setPhone(formattedNumber, isValid) {
      this.phone_number = { formattedNumber, isValid };
      this.$emit("input", this.phone_number);
    }
  },
  watch: {
    value: {
      handler(value, oldValue) {
        if (value?.formattedNumber !== oldValue?.formattedNumber) {
          this.phoneModel = value?.formattedNumber;
          const parsedNumber = typeof value?.formattedNumber === 'string'
                ? parsePhoneNumberFromString(value.formattedNumber)
                : null;
          if (parsedNumber) {
            this.defaultCountryCode = parsedNumber.country;
          }
        }
      },

      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped></style>
